import TrackingLink from '../link/tracking-link'

export default props => {
  return <a {...props} class='main-menu-link link--text'>{props.children}</a>
}

export const CategoryLink = props => {
  return (
    <TrackingLink {...props} class='link--text main-menu-link main-menu-link--category'>
      <span>{props.children}</span>
      <span className='text--meta'>{props.topicsCount}</span>
    </TrackingLink>
  )
}
